import type { SVGProps } from "react";
export default function SvgOnedrive(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			viewBox="0 0 48 48"
			{...props}
		>
			<path fill="#084593" d="M24.5 8a14.5 14.5 0 1 0 0 29 14.5 14.5 0 1 0 0-29" />
			<path
				fill="#0556ab"
				d="M16.155 15.972a11.9 11.9 0 0 0-4.25-.781C5.33 15.191 0 20.521 0 27.096c0 2.476.757 4.774 2.05 6.678.061-.026 16.445-6.889 26.406-10.888-5.504-3.318-10.553-6.245-12.301-6.914"
			/>
			<path
				fill="#18b0ff"
				d="M48 29.373a9.627 9.627 0 0 0-9.627-9.627c-.997 0-1.958.152-2.863.433-.996.31-3.652 1.342-7.054 2.708 8.377 5.05 17.79 10.996 18.252 11.288A9.6 9.6 0 0 0 48 29.373"
			/>
			<path
				fill="#2cceff"
				d="M46.709 34.175c-.463-.292-9.875-6.238-18.252-11.288C18.495 26.885 2.111 33.748 2.05 33.774 2.467 34.388 5.627 39 11.904 39h26.354c5.411 0 7.89-3.854 8.451-4.825"
			/>
		</svg>
	);
}
